export default __webpack_public_path__ + "367734d035edce6f99b426c43070d5b4.png";